import { Component, Injectable, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router} from '@angular/router';
import { ConvocatoriaService } from 'app/services/convocatoria.service';
import { BsModalRef} from 'ngx-bootstrap/modal';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EvaluacionService } from 'app/services/evaluacion.service';
import { ExpedienteService } from 'app/services/expediente.service';


@Component({
  selector: 'app-asignacion-evaluaciones',
  templateUrl: './asignacion-evaluaciones.component.html',
  styleUrls: ['./asignacion-evaluaciones.component.scss']
})
export class AsignacionEvaluacionesComponent implements OnInit {

  convocatoria?: string;
  idconvocatoria?: string;
  idcentro?: string;
  closeBtnName?: string;
  list: any[] = [];
  expedientes: any;
  loading: boolean;
  universidades: any;
  centros: any[] = [];
  tiposEvaluacion: any;
  evaluadores: any;
  idtipoevaluacion: any;

  constructor(public activeModal: NgbActiveModal,private evaluacionService: EvaluacionService,private expedienteService: ExpedienteService,private convocatoriaService: ConvocatoriaService,private router: Router,private route: ActivatedRoute) { 
    
  }

  ngOnInit() {
    this.loadUniversidades();
  }



  loadUniversidades() {
    this.convocatoriaService.getTiposEvaluacion(this.idconvocatoria).subscribe(
      data => {
        this.tiposEvaluacion = data.TIPOS;
        console.log(data);
      },
      error => {
        if (error.status = 401) {alert('Error'); }
      }
    );


  }




  loadEvaluadores(event) {
    this.loading=true;
    this.idtipoevaluacion=event.target.value;
    this.expedienteService.getEvaluadoresDisponibles(this.idcentro,this.idconvocatoria,event.target.value).subscribe(
      data => {
        this.evaluadores = data.evaluadores;
        console.log(data);
        this.loading=false;
      },
      error => {
        if (error.status = 401) {alert('Error'); }
      }
    );
  }


  guardar() {
    let listAsignacionesFallidas: string[] = [];
    this.evaluadores.forEach(element => {
      //list.push(element.Id);
      if(element.checked){
        console.log(element.idexperto)
        this.evaluacionService.post(this.idconvocatoria, this.idcentro, this.idtipoevaluacion,element.idexperto).subscribe(
          // tslint:disable-next-line:max-line-length
          data => {  },
          error => {if (error.status = 401) {listAsignacionesFallidas.push(element.nombre+" "+element.apellido1);}}
        );

      };
    });

    if (listAsignacionesFallidas.length>0){alert("La asignación a los siguientes evaluadores no ha sido realizada:" + listAsignacionesFallidas)}

    this.activeModal.close();

  }
  
}



// WEBPACK FOOTER //
// /app/src/app/modules/expedientes/asignacion-evaluaciones/asignacion-evaluaciones.component.ts